require('ember');
require('./cldr');
require('./ember-i18n');